module.exports = __webpack_public_path__ + "static/sponsor-07-3662099ffa25e206efde381ecb96ee8e.svg";